import Link from 'next/link';
import type {FC} from 'react';
import {
  PageTabConstants,
  type PageTabType,
} from '../../../../core/entities/clip/constants';
import {usePageTabColors} from '../../usecases/usePageTabColors';

type PageTabForMobileItemProps = {
  keyName: string;
  url: string;
};

export const PageTabForMobileItem: FC<PageTabForMobileItemProps> = ({
  keyName,
  url,
}) => {
  const tabName = PageTabConstants.TAB_NAME[keyName as PageTabType];
  const {bgColor, textColor} = usePageTabColors({url});

  return (
    <li className="block w-[33%]">
      <Link
        href={url}
        className={`block h-36 w-full text-base ${bgColor} text-center font-bold leading-[32px] ${textColor}`}
      >
        {tabName}
      </Link>
    </li>
  );
};
